// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditProfileForm-editProfileSectionWrapper-pudag {
    padding: 24px;
    border-radius: var(--radius-3);
    background-color: var(--background-primary);
}

.EditProfileForm-editProfilesTitle-mATy5 {
    font-size: 20px;
    font-weight: 700;
    line-height: 30px;
    color: var(--primary-foreground);
    margin-bottom: 18px;
    text-align: start;
}

.EditProfileForm-editProfileBtnGrp-qJodm {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: end;
        -ms-flex-pack: end;
            justify-content: flex-end;
    -webkit-column-gap: 18px;
       -moz-column-gap: 18px;
            column-gap: 18px;
    row-gap: 18px;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    margin-top: 6px;
}

.EditProfileForm-phoneNumberAddon-SWKtc {
    border: 1px solid var(--primary-border);
    background-color: var(--primary-disable);
}`, "",{"version":3,"sources":["webpack://./src/components/EditProfileForm/EditProfileForm.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,2CAA2C;AAC/C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;IAChC,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,qBAAyB;QAAzB,kBAAyB;YAAzB,yBAAyB;IACzB,wBAAgB;OAAhB,qBAAgB;YAAhB,gBAAgB;IAChB,aAAa;IACb,mBAAe;QAAf,eAAe;IACf,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,eAAe;AACnB;;AAGA;IACI,uCAAuC;IACvC,wCAAwC;AAC5C","sourcesContent":[".editProfileSectionWrapper {\n    padding: 24px;\n    border-radius: var(--radius-3);\n    background-color: var(--background-primary);\n}\n\n.editProfilesTitle {\n    font-size: 20px;\n    font-weight: 700;\n    line-height: 30px;\n    color: var(--primary-foreground);\n    margin-bottom: 18px;\n    text-align: start;\n}\n\n.editProfileBtnGrp {\n    display: flex;\n    justify-content: flex-end;\n    column-gap: 18px;\n    row-gap: 18px;\n    flex-wrap: wrap;\n    align-items: center;\n    margin-top: 6px;\n}\n\n\n.phoneNumberAddon {\n    border: 1px solid var(--primary-border);\n    background-color: var(--primary-disable);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editProfileSectionWrapper": `EditProfileForm-editProfileSectionWrapper-pudag`,
	"editProfilesTitle": `EditProfileForm-editProfilesTitle-mATy5`,
	"editProfileBtnGrp": `EditProfileForm-editProfileBtnGrp-qJodm`,
	"phoneNumberAddon": `EditProfileForm-phoneNumberAddon-SWKtc`
};
module.exports = ___CSS_LOADER_EXPORT___;
